import React from 'react';
import PropTypes from 'prop-types';
import defaultOnErrorHandler from '../../../../shared/default-on-error-handler';
import {
  Section,
  SectionDetails,
  SectionSeparator,
  SectionSummary,
  SectionSummaryDescription,
  SectionSummaryTitle,
} from './styles';
import TextArea from '../../../shared/text-area';
import { usePostUpdateBlurb } from '../../../../services/profiles/contributor-settings-service';

export default function About({ blurb, onUpdate }) {
  const [{ loading, error }, post] = usePostUpdateBlurb();

  React.useEffect(() => {
    error && defaultOnErrorHandler(error, 'Error saving about you');
  }, [error]);

  const label = 'About You';
  const taProps = {
    label,
    value: blurb,
    placeholder: label,
    height: 204,
    limit: 750,
    isLoading: loading,
    onChange: v => post(v).then(() => onUpdate({ blurb: v })),
  };

  return (
    <>
      <SectionSeparator />
      <Section className="form-group">
        <SectionSummary>
          <SectionSummaryTitle>{label}</SectionSummaryTitle>
          <SectionSummaryDescription>
            Provide the audience with a interesting overview about you!
            Share an insight into who you are, the focus of your work, research
            or analysis. How do you like to work? Why do you do what you do?
          </SectionSummaryDescription>
        </SectionSummary>
        <SectionDetails>
          <TextArea {...taProps} />
        </SectionDetails>
      </Section>
    </>
  );
}

About.propTypes = {
  blurb: PropTypes.string,
  onUpdate: PropTypes.func,
};
About.defaultProps = {
  blurb: null,
  onUpdate: () => null,
};
